import React from "react";

function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.184"
      height="38.184"
      viewBox="0 0 38.184 38.184"
    >
      <path
        fill="#78a1bb"
        d="M1107.667 35.333h-6v-27h27v6h-21z"
        data-name="Path 43"
        transform="rotate(-45 563.82 1343.541)"
      ></path>
      <path
        fill="#78a1bb"
        d="M1106.667 22.851h-4V9.333h13.518v4h-9.518z"
        data-name="Path 44"
        transform="rotate(-45 569.82 1329.056)"
      ></path>
    </svg>
  );
}

export default BackIcon;
